const _state = {
  providerId: null,
  providers: {
    count: 0,
    currentPage: 0,
    data: [],
    pageCount: 0,
    totalItemCount: 0,
    searched: false,
  },
  providersList: [],
  statuses: [
    { id: true, name: 'Activo' },
    { id: false, name: 'Inactivo' },
  ],
  proposal: {
    academicYears: [],
    defaultAcademicYear: 0,
    areas: [],
    evaluators: [],
    statuses: [],
    providers: [],
  },
  years: [],
  municipalities: [],
  companyTypes: [],
  companySSN: null,
};

export const initialState = () => _state;

export const state = initialState();
